import { useEffect, useState } from "react";
// Components
import {
  CurrentPageInputField,
  GoToBackBtn,
  GoToNextBtn,
  ItemsPerPageSelector,
  MoveToFirstPageBtn,
  MoveToLastPageBtn,
} from "./components";
// Store Utils
import { useSelector } from "react-redux";
import { RootState } from "store";
import { useDispatch } from "react-redux";
import {
  reportsItemsPerPageLimitAction,
  reportsProfileLimitAction,
  reportsProfilePaginationAction,
  reportsVersionPaginationAction,
  reportsVersionsLimitAction,
} from "store/filters/reducer.actions";
// types
import { PaginationProps, handleChangeOnCurrentPageInputField } from "./types";
import { filtersInitialState } from "store/filters/initialState";
import { IfetchProfileReports } from "store/reportsProfile/initialState";

export const Pagination: React.FC<PaginationProps> = ({
  changePageByInput,
  currentPage,
}) => {
  // console.log(  changePageByInput,
  //   currentPage, "<= paginations ");

  const { reportsVersionFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  const [pageInput, setPageInput] = useState<any>();
  const { reportProfileFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  const { data } = useSelector<RootState, IfetchProfileReports>(
    (state) => state?.reportsProfile
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setPageInput(reportsVersionFilter.page);
  }, [reportsVersionFilter.page]);

  // Handlers
  const handleChangeItemsPerPage = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { value } = event.target;
    dispatch(reportsVersionsLimitAction(parseInt(value)));
    dispatch(reportsItemsPerPageLimitAction(parseInt(value)));
  };
  const handleClickOnMoveToFirstPageBtn = () => {
    dispatch(reportsVersionPaginationAction(1));
  };
  const handleClickOnGoToBackBtn = () => {
    dispatch(
      reportsVersionPaginationAction(
        reportsVersionFilter.page > 1 ? reportsVersionFilter.page - 1 : 1
      )
    );
    dispatch(
      reportsItemsPerPageLimitAction(
        reportsVersionFilter.itemsPerPage - reportsVersionFilter.limit
      )
    );
  };
  const handleClickOnGoToNextBtn = () => {
    dispatch(
      reportsVersionPaginationAction(
        reportsVersionFilter.page < reportsVersionFilter.totalPages
          ? reportsVersionFilter.page + 1
          : data.totalPages
      )
    );
    dispatch(
      reportsItemsPerPageLimitAction(
        reportsVersionFilter.itemsPerPage + reportsVersionFilter.limit
      )
    );
  };
  const handleClickOnMoveToLastPageBtn = () => {
    dispatch(reportsVersionPaginationAction(reportsVersionFilter.totalPages));
  };
  const handleChangeOnCurrentPageInputField: handleChangeOnCurrentPageInputField =
    (e) => {
      const value = e.target.value;
      setPageInput((prevValue: any) => {
        if (value === "" || !isNaN(parseInt(value))) {
          if (
            parseInt(value) <= reportsVersionFilter.totalPages &&
            parseInt(value) > 0
          ) {
            if (!isNaN(parseInt(value))) {
              dispatch(reportsVersionPaginationAction(parseInt(value)));
            } else {
              dispatch(reportsVersionPaginationAction(1));
            }
            dispatch(
              reportsItemsPerPageLimitAction(
                Number(value) * reportsVersionFilter.limit
              )
            );
            return value;
          }
        }
        return "";
      });
    };
  const handleBlurOnCurrentPageInputField = () => {
    setPageInput(reportsVersionFilter.page);
  };
  return (
    <div className="flex items-start self-stretch justify-start flex-grow-0 flex-shrink-0 px-6 pt-8 pb-10 bg-white rounded-bl-lg rounded-br-lg">
      <div className="flex items-center justify-start flex-grow">
        <ItemsPerPageSelector
          handleChangeItemsPerPage={handleChangeItemsPerPage}
          limit={reportsVersionFilter.limit}
        />
        <div className="flex items-center justify-center flex-grow-0 flex-shrink-0 gap-2">
          <MoveToFirstPageBtn
            page={reportsVersionFilter.page}
            handleClickOnBtn={handleClickOnMoveToFirstPageBtn}
          />
          <CurrentPageInputField
            pageInput={pageInput}
            handleChangeOnInput={handleChangeOnCurrentPageInputField}
            handleBlurOnInput={handleBlurOnCurrentPageInputField}
          />
          <div className="flex items-center justify-center flex-grow-0 flex-shrink-0 gap-1 px-3 py-1 rounded-lg">
            <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative pt-0.5">
              <p className="flex-grow-0 flex-shrink-0 text-[15px] text-center text-textMid dark:text-caption ">
                of {reportsVersionFilter.totalPages}
              </p>
            </div>
          </div>
          <GoToBackBtn
            page={reportsVersionFilter.page}
            handleClickOnBtn={handleClickOnGoToBackBtn}
          />
          <GoToNextBtn
            page={reportsVersionFilter.page}
            totalPages={reportsVersionFilter.totalPages}
            handleClickOnBtn={handleClickOnGoToNextBtn}
          />

          <MoveToLastPageBtn
            page={reportsVersionFilter.page}
            totalPages={reportsVersionFilter.totalPages}
            handleClickOnBtn={handleClickOnMoveToLastPageBtn}
          />
        </div>
      </div>
    </div>
  );
};
